export const CORE_API = 'https://core.uniteus.io/v1/';
export const UPLOADS_API = 'https://uploads.uniteus.io/v1/';
export const LEGACY_API_URL = 'https://api.uniteus.io';
export const CORE_LEGACY_API_URL = 'https://core.uniteus.io/legacy/';
export const SERVER_URL = 'https://widgets.uniteus.io/';
export const AWS_DOC_URL = 'https://s3.amazonaws.com/documents.uniteus.io/';
export const LAUNCH_DARKLY_KEY = '67cb3815081533095a007486';
export const SCREENINGS_API = 'https://screenings-ingestion.uniteus.io/v2';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCGV28YrMBuBzlL1ntXMCvW1Z0RT1_RsVU';
